import React, { ReactElement } from 'react';
import {
  getListboxOptionState,
  shouldShowListboxDivider,
  toggleOptionInSelection,
} from '../../../../utils/utils';
import { MultipleSelectListboxOption } from '../../../MultipleSelectListboxOption';
import { MultipleSelectOption } from '../../../..';
import { MultipleSelectListboxDivider } from '../MultipleSelectListboxDivider';

export type MultipleSelectListboxItemProps = {
  option: MultipleSelectOption;
  index: number;
  optionsLength: number;
  fieldId: string;
  value: string[];
  isSelectAllActive: boolean;
  onChange: (value: string[]) => void;
};

export function MultipleSelectListboxItem({
  option,
  index,
  optionsLength,
  fieldId,
  value,
  isSelectAllActive,
  onChange,
}: MultipleSelectListboxItemProps): ReactElement {
  const { isSelected, disabled } = getListboxOptionState(
    option,
    value,
    isSelectAllActive,
  );
  const showDivider = shouldShowListboxDivider(option, index, optionsLength);

  return (
    <>
      <MultipleSelectListboxOption
        option={option}
        fieldId={fieldId}
        isSelected={isSelected}
        disabled={disabled}
        onSelect={(optionValue) =>
          onChange(toggleOptionInSelection(value, optionValue))
        }
      />
      <MultipleSelectListboxDivider showDivider={showDivider} />
    </>
  );
}
